@if (corporateTaxEntity$ | async) {
  <form [formGroup]="functioneleValutaFg">
    <snelstart-ui-select-form-control
      [options]="optionsValutaCode"
      class="custom-input-250"
      formControlName="valutaCode"
      id="valutaCode"
      label="Valutacode"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-number-form-control
      [showAllDecimals]="false"
      align="right"
      class="custom-input-250"
      formControlName="gemiddeldeKoersFunctioneleValuta"
      id="gemiddeldeKoersFunctioneleValuta"
      label="Gemiddelde koers"
      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control
      [showAllDecimals]="true"
      align="right"
      class="custom-input-250"
      formControlName="valutaFactorFunctioneleValuta"
      id="valutaFactorFunctioneleValuta"
      label="Valutafactor"
    >
    </snelstart-ui-number-form-control>
  </form>
}
